// This function allow to reference chunks
__webpack_require__.u = (chunkId) => {
  // return url for filenames not based on template
  if (chunkId === "362") return "static/js/async/__federation_expose_App.fdfaaa80.js";
  // return url for filenames based on template
  return "static/js/" + ({"328": "lib-vue","535": "lib-router",}[chunkId] || chunkId) + "." + {"328": "27aa82e3","535": "dc888d0c","545": "cbdb4d1f","71": "d6845738",}[chunkId] + ".js"
}